module.exports = __webpack_public_path__ + "img/missing.d2032b06.svg";